module.exports = __webpack_public_path__ + "img/mini-avatar6.1e753b5f.png";